export enum FeatureWishlistInputNames {
  WishlistEnabled = 'wishlistEnabled',
  WishlistItems = 'wishlistItems',
}
